import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@features/auth/AuthContext";
import type { Role } from "@/types/session";
import type { ReactNode } from "react";

type Props = {
  roles?: Role[];
  children?: ReactNode;
};

export function ProtectedRoute({ roles, children }: Props) {
  const { user, loading, hasRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="p-24 text-center text-muted">Cargando sesión…</div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (roles && !hasRole(...roles)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children ?? <Outlet />}</>;
}
